// Prevent jQuery from clashing with other libraries that use the $ alias
$.noConflict();

jQuery(function ($) {

    $('.navbar-nav').adaptiveNavigation();
    $('.event-card').eventify();
    $('.event-alert').eventAlert();
    $('.expander').expander();

    // List methods in alphabetical order
    croppedImagesFix();
    maybeEnhanceBreadcrumb();
    enhanceContextualNav();
    // hideShowSecondaryNav();
    hideShowContextualNav();
    hideAndShowMobileSearch();
    hideShowSuImageHeadingStraplineBackground();
    lightbox();
    makeTableScrollable();
    navToggle();
    sliderGroup();
    photoGallery();
    featuredImageGallery();
    responsiveIframes();
    relatedActionsLink();
    searchToggle();
    smoothScrollToElement();
    tabFunctionality();
    tabNavFunctionality();
    // textFillCaptions();


    executeInjectedScripts();

    $(window).scroll(function(){
        addStickyNavBarAndCourseCTA();
    });

    function croppedImagesFix() {
        var targets = [
            '.call-to-action-image-image',
            '.image-and-text-image',
            '.news-article-card-image',
            '.news-article-title-and-body-text-image',
            '.slider-card-image',
            '.staff-contact-card-body-profile-picture',
            '.staff-profile-overview-profile-picture',
            '.su-featured-image-image',
            '.su-featured-image',
            '.su-image-content-image'
        ];
        if (! Modernizr.objectfit) {
            console.log("Object fit is not supported");
            $(targets.join(',')).each(function() {
                var $container = $(this),
                    imgUrl = $container.find('img').prop('src');

                if (imgUrl) {
                    $container
                        .css('backgroundImage', 'url("' + imgUrl + '")')
                        .addClass('compat-object-fit');
                }
            });
        }
    }

    function addStickyNavBarAndCourseCTA() {
      var navbar = $('.navbar'),
          featuredCourseSticky = $('.featured-course-sticky');

      if($(window).scrollTop() >= 600) {
          featuredCourseSticky.addClass('visible');
      } else {
          featuredCourseSticky.removeClass('visible');
      }
    }

    function maybeEnhanceBreadcrumb() {
        var $container = $('.desktop-breadcrumb');
        if (! Modernizr.touchevents) {
            $container.jBreadCrumb({
                minimumCompressionElements: 2,
                previewWidth:               20,
                timeExpansionAnimation:     400,
                timeInitialCollapse:        400,
            });
        }
    }

    function enhanceContextualNav() {
        var currentHref = window.location.pathname,
            $contextualNav = $('.contextual-nav');

        $contextualNav.find('a[href="' + currentHref + '"]')
            .parentsUntil($contextualNav, 'li')
            .addClass('selected');
    }

    function makeTableScrollable(){
        $('table').not('.su-embed-code table').wrap('<div class="table-responsive"></div>');
    }

    function hideShowSecondaryNav() {
        $('.layout-content-nav').listMuncher({
          button: ".layout-content-nav button",
          hiddenList: ".layout-content-nav .hidden-links",
          visibleList: ".layout-content-nav .content-nav-items",
          excludeClass: "content-nav-item--button",
          itemClass: "content-nav-item",
          hiddenClass: "d-none",
          mobileButtonText: "Section menu",
          breakPointSize: 767
        });

        $('.tabs-pod-tabs').listMuncher({
          button: ".tabs-pod-tabs .tabs-more-btn",
          hiddenList: ".tabs-pod-tabs .hidden-tabs",
          visibleList: ".tabs-pod-tabs .tabs-item-list",
          itemClass: "tabs-item-list-tab-item",
          excludeClass: "wcontent-nav-item--button",
          hiddenClass: "d-none",
          mobileButtonText: "More",
          breakPointSize: 767
        });
    }

    function hideShowContextualNav() {
        var $contextualNavViewer = $('#contextualNavViewer'), $contextualNav = $('.contextual-nav');

        $contextualNavViewer.click(function(){
            if(!$($contextualNav).is(':visible')){
                $contextualNavViewer.addClass('is-shown');
                $contextualNav.show();
            }else{
                $contextualNavViewer.removeClass('is-shown');
                $contextualNav.hide();
            }


        });

    }

    function hideAndShowMobileSearch() {
       var $primaryNavSearchAnchor = $('.primary-nav-search-anchor');

       $primaryNavSearchAnchor.click(function(){
          var primaryNavForm = $('.primary-nav-form');

          if(primaryNavForm.css('display') == 'none') {
             console.log(1);
             primaryNavForm.slideDown();
          } else {
             console.log(2);
             primaryNavForm.slideUp();
          }

       });
    }

    function hideShowSuImageHeadingStraplineBackground() {
        var $suImage = $('.su-image'),
            $suImageHeading = $('.su-image-heading'),
            $suImageStrapline = $('.su-image-strapline');

        $($suImage).mouseover(function(){

            $(this).find($suImageHeading).has('a').parent().addClass('su-image-is-hover');
            $(this).find($suImageStrapline).has('a').parent().addClass('su-image-is-hover');
        });

        $($suImage).mouseout(function(){
            $(this).find($suImageHeading).has('a').parent().removeClass('su-image-is-hover');
            $(this).find($suImageStrapline).has('a').parent().removeClass('su-image-is-hover');
        });
    }


    // Popup functionality, both images and video embeds
    function lightbox() {
        $('.video-popup').magnificPopup({
            type: 'iframe',
            iframe: {
                patterns: {
                    youtube: {
                        // Stop related videos from appearing at the end of the video player
                        src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0&showinfo=0'
                    }
                }
            }
        });
    }

    // Expand/collapse navigation menu
    function navToggle() {
      $( "#nav-primary" ).navSlidingTree();
    }

    function relatedActionsLink() {
        $('.related-actions-link').on('click', function (e) {
           var $relatedActionsSel = $(this).next('.related-actions');

           $relatedActionsSel.toggle();

            if($relatedActionsSel.hasClass('related-actions-show')){
               $relatedActionsSel.removeClass('related-actions-show');
            }else{
               $relatedActionsSel.addClass('related-actions-show');
            }
            e.preventDefault();
        });
    }

    function sliderGroup() {
        $('.slider-group-cards').slick({
            dots: false,
            mobileFirst: true,
            autoplaySpeed: 5000,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });
    }

    function responsiveIframes() {
        $("iframe[src*='www.youtube.com'], iframe[src*='player.vimeo.com']").wrap("<div class='su-iframe-responsive'></div>");
    }

    function tabFunctionality() {
        var tabHeadings = $('.tabs-item-list-tab-item a');

        tabHeadings.on('click', function (e) {
            e.preventDefault();

            var _this = $(this);

            // Get parent tab heading li's index
            var parentIndex = _this.parent().index();

            // Remove all selected tab heading classes
            tabHeadings.removeClass('selected');

            // Add selected tab heading class to this tab heading
            _this.addClass('selected');

            // Get all tabs in this tab pod
            var tabs = $(this).closest('.tabs-pod-tabs').children('.tabs-pod-tabs-tab');

            // Hide all tabs
            tabs.hide();

            // Show the tab with the same index as this tab heading
            tabs.eq(parentIndex).show();

        });
    }

    function photoGallery(){
        $('.gallery-scroll-image-list').slick({
            dots: true,
            dotsClass: 'gallery-options-list',
            arrows: true,
        });
    }

    function featuredImageGallery(){
        $('.sliding-featured-image-group').slick({
            dots: true,
            autoplay: true,
            autoplaySpeed: 5000,
            fade: true,
            cssEase: 'linear',
            adaptiveHeight: true,
        });
    }

    // Search Toggle
    function searchToggle() {
        var $keywords = $('#keywords');

        $keywords.focus(function (e) {
            $('#search-button').addClass('is-focused');
            $keywords.val('');

        });
    }

    function smoothScrollToElement() {
        $('.featured-course-content-header-arrow').on('click', function () {
            $('html,body').animate({ scrollTop: $('.featured-course-content-header-arrow').offset().top }, 'slow');
            return false;
        });

    }

    function stickyLinks() {
      var nav = $('.layout-content-nav');
      var offset = nav.offset().top;
      var mobile = 768;

      if (window.outerWidth > mobile && nav.length > 0) {
        $(window).scroll(function(){
          if ($(window).scrollTop() >= offset) {
            nav.addClass('fixed-header');
          }
          else {
            nav.removeClass('fixed-header');
          }
        });
      }
    }

    function tabNavFunctionality() {
        $('.tab-nav-links a, .hidden-links a').on('click', function (e) {
          $('.tab-nav-tab').hide();
          $($(this).attr('href')).fadeIn();

          $("html, body").animate({
            scrollTop:  $($(this).attr('href')).offset().top - 100
          }, 1000);

          e.preventDefault();
        });
    }

    function executeInjectedScripts()
    {
        var execute = function (scripts) {
                var i,
                    count = scripts.length;
                for (i = 0; i < count; i += 1) {
                    if ($.isFunction(scripts[i])) {
                        scripts[i]($);
                    }
                }
            };

        if ($.isArray(SU.injectedScripts)) {
            execute(SU.injectedScripts);
        }
    }
});

 (function ($) {
    var serviceUrl = "//api.reciteme.com/asset/js?key=";
    var serviceKey = "1bc7b5c004c4546e9be42887b4f57d3ae9e7c121";
    var options = {};  // Options can be added as needed
    var autoLoad = false;
    var enableFragment = "#reciteEnable";
    var loaded = [],
        frag = !1;
    window.location.hash === enableFragment && (frag = !0);

    function loadScript(c, b) {
        var a = document.createElement("script");
        a.type = "text/javascript";
        a.readyState ? a.onreadystatechange = function() {
            if ("loaded" == a.readyState || "complete" == a.readyState) a.onreadystatechange = null, void 0 != b && b()
        } : void 0 != b && (a.onload = function() {
            b()
        });
        a.src = c;
        document.getElementsByTagName("head")[0].appendChild(a)
    }

    function _rc(c) {
        c += "=";
        for (var b = document.cookie.split(";"), a = 0; a < b.length; a++) {
            for (var d = b[a];
                " " == d.charAt(0);) d = d.substring(1, d.length);
            if (0 == d.indexOf(c)) return d.substring(c.length, d.length)
        }
        return null
    }

    function loadService(c) {
        for (var b = serviceUrl + serviceKey, a = 0; a < loaded.length; a++)
            if (loaded[a] == b) return;
        loaded.push(b);
        loadScript(serviceUrl + serviceKey, function() {
            "function" === typeof _reciteLoaded && _reciteLoaded();
            "function" == typeof c && c();
            Recite.load(options);
            Recite.Event.subscribe("Recite:load", function() {
                Recite.enable()
            })
        })
    }
    "true" == _rc("Recite.Persist") && loadService();
    (autoLoad && "false" != _rc("Recite.Persist") || frag) && loadService();

    loadScript(serviceUrl + serviceKey, function () { _reciteLoaded(); });

    function _reciteLoaded() {
        Recite.Event.subscribe('Controls:loaded', function () {
            $('ul#recite-languages li[data-language="cy"]').hide();
        });

        $('.machine-translate-to-welsh').each( function () {
            $(this).attr('lang', 'en');
            Recite.Language.Translate.translate(this, 'cy');
        });
    }

    $(".utility-links-recite-me-link").click(function(i,e){
        loadService();
        console.log('call recite me');
        return false;
    });
})(jQuery);
